<template>
	<div id="app">
		<head-nav
			v-show="$route.name!='login'"
			:userId="userId"
			:name="name"
			:allMessageNum="allMessageNum"
			:unreadMessageNum="unreadMessageNum"
			:userMessageNum="userMessageNum"
			ref="headFun">
		</head-nav>
		<left-nav ref="leftFun" v-show="$route.name!='login'"></left-nav>
		<div :class="$route.name=='login'?'':'xk-app-content'">
				<keep-alive>
		      <router-view v-if="$route.meta.keepAlive"></router-view>
		    </keep-alive>
		    <router-view v-if="!$route.meta.keepAlive"></router-view>
					
		</div>
	</div>
</template>

<script>
import headNav from './components/header'
import leftNav from './components/leftNav'
export default {
	name: 'App',
	components: {
		headNav,
		leftNav
	},
	data() {
		return {
			userId: sessionStorage.getItem("userId"),
			name: sessionStorage.getItem("name"),
			allMessageNum: '0',
			unreadMessageNum: '0',
			userMessageNum: '0',
			loginLoading: true
		}
	},
	
	mounted() {
		//初始化更新title
		this.$nextTick().then(() => {
			setTimeout(() => {
				this.loginLoading = false;
			//	this.init();
			}, 300)
		});
		this.allMessageNum = sessionStorage.getItem("allMessageNum");
		this.unreadMessageNum = sessionStorage.getItem("unreadMessageNum");
		this.userMessageNum = sessionStorage.getItem("userMessageNum");
		this.name=sessionStorage.getItem("name");
	},
	methods: {
		init() {
			const title = this.$route.meta.title || '';
			document.body.scrollTop = document.documentElement.scrollTop = 0;
			document.title = title;
			this.$refs.leftFun.init();
			if(title!=""){
				this.$refs.headFun.init();
			}
			
		}
	},
	watch: {
		$route(to, from) {
			//路由发生变化更新title
			this.init();
		}
	}
}
</script>
<style>
.xk-app-content {
	position: absolute;
	top: 5rem;
	right: 0;
	width: calc(100% - 235px);
	box-sizing: border-box;
	overflow: auto;
	bottom: 0;
}
.important-days {
	position: relative;
}
.important-days::after {
	content: "";
	position: absolute;
	top: 10px;
	right: 10px;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background-color: #ff0000;
}
</style>


// WEBPACK FOOTER //
// src/App.vue